module.exports = __webpack_public_path__ + "img/reels-instagram.52546a0.jpg";